import { Avatar, Box, Chip, Typography } from "@mui/material";
import { ArrowForwardIos, School } from "@mui/icons-material";

const capitalizeWords = (text = "") => {
  if (!text) return "";
  return String(text)
    .toLowerCase()
    .replace(/\b\w/g, (letter) => letter.toUpperCase());
};

const DoctorSearchCard = ({ doctor, onClick }) => {
  const fullName = [
    doctor.nombre,
    doctor.apellido_paterno,
    doctor.apellido_materno,
  ]
    .filter(Boolean)
    .join(" ");
  const specialtyStyle = specialtyColors[doctor.especialidad] || {
    bg: "#EEF2FF",
    color: "#2349D0",
  };

  return (
    <Box onClick={() => onClick?.(doctor)} sx={design.CardContainer}>
      <Box sx={design.BoxAvatar}>
        <Avatar src={doctor.imagen} alt={fullName} sx={design.Avatar} />
      </Box>
      {/* Información */}
      <Box flex={1} minWidth={0}>
        {/* Nombre + Especialidad */}
        <Box sx={design.BoxNameSpecialty}>
          <Typography sx={design.Name}>{fullName}</Typography>
          <Chip
            label={doctor.especialidad}
            size="small"
            sx={design.Chip(specialtyStyle)}
          />
        </Box>
        <Box sx={design.BoxCenter}>
          <School sx={design.SchoolIcon} />
          <Typography sx={design.TypographyCenter}>
            No. Cédula {doctor.cedula} -{" "}
            {capitalizeWords(doctor?.centro_estudios)}
          </Typography>
        </Box>
      </Box>
      {/* Flecha */}
      <ArrowForwardIos sx={design.SchoolIcon} />
    </Box>
  );
};

export default DoctorSearchCard;

const specialtyColors = {
  "Medicina General": {
    bg: "#E8F5E9",
    color: "#2E7D32",
  },
  Cardiología: {
    bg: "#FDECEC",
    color: "#D32F2F",
  },
  Pediatría: {
    bg: "#E3F2FD",
    color: "#1565C0",
  },
  Ginecología: {
    bg: "#FCE4EC",
    color: "#AD1457",
  },
  Traumatología: {
    bg: "#FFF8E1",
    color: "#F57F17",
  },
  Neurología: {
    bg: "#EDE7F6",
    color: "#5E35B1",
  },
};

const design = {
  CardContainer: {
    display: "flex",
    alignItems: "center",
    gap: 1,
    p: 1,
    cursor: "pointer",
    borderRadius: 4,
    transition: "all .25s ease",
    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: "0 2px 10px rgba(35,73,208,.12)",
    },
  },
  BoxAvatar: {
    border: "1px solid #2349D0",
    borderRadius: "50%",
  },
  Avatar: {
    width: 60,
    height: 60,
    bgcolor: "#fff",
  },
  BoxNameSpecialty: {
    display: "flex",
    justifyContent: {
      xs: "column",
      sm: "space-between",
      md: "space-between",
      xl: "space-between",
    },
    alignItems: "flex-start",
    gap: 1,
  },
  Name: {
    fontSize: 18,
    fontWeight: 700,
    color: "#1F2937",
    lineHeight: 1.25,
    fontFamily: "Plus Jakarta Sans",
    flex: 1,
  },
  Chip: (specialtyStyle) => ({
    bgcolor: specialtyStyle.bg,
    color: specialtyStyle.color,
    fontWeight: 700,
    fontSize: 11,
    height: 26,
    borderRadius: 2,
    flexShrink: 0,
    "& .MuiChip-icon": {
      color: specialtyStyle.color,
    },
  }),
  BoxCenter: {
    display: "flex",
    alignItems: "flex-start",
    gap: 1,
    mt: 1,
  },
  SchoolIcon: {
    color: "#64748B",
    fontSize: 18,
    mt: "2px",
  },
  TypographyCenter: {
    fontSize: 13,
    color: "#64748B",
    lineHeight: 1.45,
    fontFamily: "Plus Jakarta Sans",
  },
};
